module.exports = __webpack_public_path__ + "static/media/mob2.0ceb55ee.jpeg";